import EventView from './EventView';

export default EventView;
